import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="text">© 2025 TechLoops Solutions</div>
    </footer>
  );
}
